import './Spinner.sass';

import React from 'react';

class Spinner extends React.Component {
  render() {
    return (
      <div className="spinnerPosition" style={this.props.style}>
        <i
          className="fa fa-circle-o-notch fa-spin"
          style={{ color: this.props.color || '' }}
        />
        <span>{this.props.text || null}</span>
      </div>
    );
  }
}

export default Spinner;
